import { cover } from '../../utility/constant/helper.constant'
import {
  TTerraceDepth,
  TTerraceModel,
  TTerraceWidth,
} from '../../utility/type/terraceCover.type'
import { DepthObserver } from './depth.class'
import { WidthObserver } from './width.class'

export interface IObserver {
  updateWidth?: (model: TTerraceModel, width: TTerraceWidth) => void
  updateDepth?: (depth: TTerraceDepth, angle: number, height: number) => void
}

interface ISubject {
  registerObserver: (observer: IObserver) => void
  removeObserver: (observer: IObserver) => void
  notifyObservers: () => void
}

export class Subject implements ISubject {
  private width: TTerraceWidth = cover.terraceCover.width
  private depth: TTerraceDepth = cover.terraceCover.depth
  private height: number = cover.terraceCover.height
  private angle: number = cover.bar.angle
  private model: TTerraceModel = cover.terraceCover.model
  private observers: IObserver[] = []

  // Width Class
  public setModel(model: TTerraceModel) {
    this.model = model
    this.notifyObservers()
    return this
  }

  public setWidth(width: TTerraceWidth) {
    this.width = width
    this.notifyObservers()
    return this
  }

  // Depth Class
  public setDepth(depth: TTerraceDepth) {
    this.depth = depth
    this.notifyObservers()
    return this
  }

  public setAngle(angle: number) {
    this.angle = angle
    this.notifyObservers()
    return this
  }

  public setHeight(height: number) {
    this.height = height
    this.notifyObservers()
    return this
  }

  /**
   * Registers an observer for the Subject class
   * @param observer The class that should be observed
   */
  public registerObserver(observer: IObserver) {
    this.observers.push(observer)
  }

  /**
   * Removes an observer from the Subject class
   * @param observer The class that should be observed
   */
  public removeObserver(observer: IObserver) {
    let index = this.observers.indexOf(observer)
    this.observers.splice(index, 1)
  }

  /**
   * A method that notifies all observers
   */
  public notifyObservers() {
    for (let observer of this.observers) {
      if (observer instanceof WidthObserver) {
        observer.updateWidth(this.model, this.width)
      }

      if (observer instanceof DepthObserver) {
        observer.updateDepth(this.depth, this.angle, this.height)
      }
    }
  }
}
